'use client'

import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { createSafeJSONStorage } from '@/utils/zustand/safe-local-storage'

interface IAppCustomizationState {
    showEditorProjectsInSidebar: boolean
    setShowEditorProjectsInSidebar: (value: boolean) => void
}

export const useAppCustomizationStore = create<IAppCustomizationState>()(
    devtools(
        persist(
            (set) => ({
                showEditorProjectsInSidebar: false,
                setShowEditorProjectsInSidebar: (value) => set({ showEditorProjectsInSidebar: value }),
            }),
            {
                name: 'app-customization-store',
                storage: createSafeJSONStorage(),
            }
        ),
        { name: 'app-customization-store' }
    )
)
